import { render, staticRenderFns } from "./ciic-tree-select.vue?vue&type=template&id=4d4bc511&scoped=true&"
import script from "./ciic-tree-select.vue?vue&type=script&lang=js&"
export * from "./ciic-tree-select.vue?vue&type=script&lang=js&"
import style0 from "./ciic-tree-select.vue?vue&type=style&index=0&id=4d4bc511&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bc511",
  null
  
)

export default component.exports